import React from 'react';
import { motion } from 'framer-motion';
interface CoverScreenProps {
  onStart: () => void;
}
export function CoverScreen({
  onStart
}: CoverScreenProps) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="min-h-screen flex flex-col justify-center items-center text-center px-5 py-10" data-id="element-33">
      <div className="max-w-[680px] w-full mx-auto flex flex-col items-center" data-id="element-34">
        <motion.img initial={{
        y: -20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.2
      }} src="https://cdn.magicpatterns.com/uploads/j5oSMX1HPmmh812g8Nqn8c/reclutas_digitales_logo_dorado.png" alt="Reclutas Digitales Logo" className="h-24 md:h-32 mb-6 object-contain" data-id="element-35" />
        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="text-[var(--gold)] text-xs tracking-[4px] font-bold mb-8 uppercase" data-id="element-36">
          RECLUTAS DIGITALES
        </motion.div>
        <motion.h1 initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.4
      }} className="text-[42px] font-extrabold mb-3 leading-[1.1] text-white" data-id="element-37">
          AUDITORÍA EXPRESS
        </motion.h1>
        <motion.p initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="text-[var(--gold)] text-lg font-semibold mb-10 leading-[1.4]" data-id="element-38">
          ¿Tu Agencia Está Diseñada para
          <br data-id="element-39" />
          Activar Reclutas o para Perderlos?
        </motion.p>
        <motion.div initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="w-[200px] h-[2px] bg-[var(--gold)] my-5" data-id="element-40" />
        <motion.p initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.7
      }} className="text-[#999999] text-sm leading-[1.6] mb-10 max-w-[400px]" data-id="element-41">
          10 preguntas. 3 minutos. Un diagnóstico claro de dónde está la falla
          en tu proceso de reclutamiento y activación de agentes de seguros.
        </motion.p>
        <motion.button initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.8
      }} whileHover={{
        scale: 1.05,
        boxShadow: '0 0 30px rgba(212,168,67,0.3)'
      }} whileTap={{
        scale: 0.95
      }} onClick={onStart} className="bg-[var(--gold)] text-[var(--black)] border-none py-4 px-12 text-base font-bold rounded-lg cursor-pointer tracking-[1px] transition-colors" data-id="element-42">
          COMENZAR AUDITORÍA
        </motion.button>
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1
      }} className="text-[#666666] text-xs mt-6" data-id="element-43">
          Basado en el Método BTS™ — Build · Track · Scale
        </motion.p>
      </div>
    </motion.div>;
}